var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99999 9.99906C6.99999 7.23764 9.23857 5 12 5V5C14.7614 5 17 7.23764 17 9.99906C17 10.6281 17 11.2987 17 12C17 13.9827 17.8599 15.7197 18.7273 16.9675C19.2572 17.7298 18.7251 19 17.7967 19H6.20325C5.27484 19 4.74278 17.7298 5.2727 16.9675C6.14006 15.7197 6.99999 13.9827 6.99999 12C6.99999 11.2987 6.99999 10.6281 6.99999 9.99906Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 4C11 3.44772 11.4477 3 12 3C12.5523 3 13 3.44772 13 4H11Z",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 20C11 20.5523 11.4477 21 12 21C12.5523 21 13 20.5523 13 20H11Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationEmpty);
export default __webpack_public_path__ + "static/media/notification_empty.ba54f0caa87bb56265cd69d9dd258339.svg";
export { ForwardRef as ReactComponent };